import React, { FC } from 'react';
import { SearchAutocompleteFetcher } from './fetcher/SearchAutocompleteFetcher';
import { SearchAutocompleteList } from './SearchAutocompleteList';

type Props = {
  query: string;
  isLoggedIn: boolean;
  onItemSelected: Function;
  updateQuery: Function;
  manualClose: Function;
};

export const SearchAutocomplete: FC<Props> = ({
  query,
  isLoggedIn,
  onItemSelected,
  updateQuery,
  manualClose,
}) => (
  <SearchAutocompleteFetcher query={query} isLoggedIn={isLoggedIn}>
    {({ items }) => (
      <SearchAutocompleteList
        items={items}
        query={query}
        isLoggedIn={isLoggedIn}
        onItemSelected={onItemSelected}
        updateQuery={updateQuery}
        manualClose={manualClose}
      />
    )}
  </SearchAutocompleteFetcher>
);
